export const messages = {
  en: {
    accountWithdrawalApply: {
      title: 'Account Withdrawal',
      queryConditions: 'Query Conditions',
      withdrawalAmount: 'Withdrawal Amount',
      applicantName: 'Applicant Name',
      applicantPhone: 'Applicant Phone',
      bankName: 'Bank Name',
      accountNumber: 'Account Number',
      applicationNote: 'Application Note',
      status: 'Status',
      editTitle: 'Edit Account Withdrawal',
      deleteConfirm: 'Are you sure to delete this account withdrawal?',
      amountRequired: 'Amount is required',
      applicantIdRequired: 'Applicant ID is required',
      nameRequired: 'Name is required',
      phoneRequired: 'Phone is required',
      noteRequired: 'Note is required'
    }
  },
  zh: {
    accountWithdrawalApply: {
      title: '账户提现',
      queryConditions: '查询条件',
      withdrawalAmount: '提现金额',
      applicantName: '申请人名称',
      applicantPhone: '申请人电话',
      bankName: '开户行',
      accountNumber: '账户',
      applicationNote: '申请说明',
      status: '状态',
      editTitle: '修改账户提现',
      deleteConfirm: '确定删除账户提现',
      amountRequired: '提现金额不能为空',
      applicantIdRequired: '申请人ID不能为空',
      nameRequired: '申请人名称不能为空',
      phoneRequired: '申请人电话不能为空',
      noteRequired: '申请说明不能为空'
    }
  }
}